export default __webpack_public_path__ + "static/media/Bitbucket-Logo.68827fd5.svg";